import VModal from 'vue-js-modal'
window.Vue = require('vue');

Vue.use(VModal)

const FORM_SELECTOR = '#quote-form'

import InputHints from './components/InputHints'

const app = new Vue({
    el: '#app',
    components: {
        'input-hints':InputHints,
    },
    computed: {
        products () {
            return Object.keys(this.values)
        },
        bars () {
            try{
                return this.selectedProduct.options
            } catch(e) {}
        },
        quantities () {
            try{
                return this.selectedBar.options
            } catch(e) {}
        },
        details () {
            try{
                return this.selectedBar.details
            } catch(e) {}
        },
        productName () {
            try{
                return this.selectedProduct.name
            } catch(e) {}

        },
        barName () {
            try{
                return this.selectedBar.name
            } catch(e) {}
        },
        quantityName() {
            try{
                return this.selectedQuantity
            } catch(e) {}
        }
    },

    data () {

        return {

            selectedProduct: '',
            selectedBar: '',
            selectedQuantity: '',
            isSubmitting: false,


            form: {
                name: '',
                email: '',
                telephone: '',
                productType: '',
                productSubType: '',
                quantity: '',
                file: '',
                additional: '',
            },

            values: {
                chocolate_bars: {
                    name: "Chocolates Bars",
                    options: {
                        bar1: {
                            name: "1lb Breakup Bar",
                            options: ["25", "50", "100", "250+"],
                        },
                        bar2: {
                            name: "2lb Breakup Bar",
                            options: ["25", "50", "100", "250+"],
                        },
                        bar3: {
                            name: "1/3oz Foil Wrapped Bar",
                            options: ["500", "1,000", "2,500", "5,000+"],
                        },
                        bar4: {
                            name: "1oz Foil Wrapped Bar",
                            options: ["25", "50", "100", "250+"],
                            // options: ["250", "500", "1,000", "2,500", "5,000+"],
                        },
                        bar5: {
                            name: "1.75oz Foil Wrapped Bars",
                            options: ["250", "500", "1,000", "2,500", "5,000+"],
                        },
                        bar6: {
                            name: "3oz Foil Wrapped Bars",
                            options: ["250", "500", "1,000", "2,500", "5,000+"],
                        },

                    }

                },
                foiled_chocolates: {
                    name: "Foiled Chocolates",
                    options: {
                        bar1: {
                            name: "Stock Chocolate Coins",
                            options: ["144", "432", "720", "1,440+"],
                        },
                        bar2: {
                            name: "Custom Chocolate Coins",
                            options: ["690", "1,300", "4,140", "11,040", "20,700+"],
                        },
                        bar3: {
                            name: "1.25\" Chocolate Foiled Square",
                            options: ["1,200", "4,800", "9,600", "21,600", "43,200+"],
                        },
                        bar4: {
                            name: "1oz Foiled Ribbon",
                            options: ["250", "500", "1,000", "2,500+"],
                        },
                        bar5: {
                            name: "1oz Non-Foiled Heart",
                            options: ["250", "500", "1,000", "2,500+"],
                        },
                        bar6: {
                            name: "1oz Foiled Heart",
                            options: ["250", "500", "1,000", "2,500+"],
                        },
                        bar7: {
                            name: "7 Hearts",
                            options: ["250", "500", "1,000", "2,500+"],
                        },

                    }

                },

                gift_boxes: {
                    name: "Gift Boxes",
                    options: {
                        bar1: {
                            name: "Custom Cookie Gift Box",
                            options: ["50", "100", "250", "500+"],
                        },
                        bar2: {
                            name: "Custom Cookie Gift Box w/ Confections",
                            options: ["50", "100", "250", "500+"],
                        },
                        bar3: {
                            name: "Cookies n' Confection Gift Box",
                            options: ["25", "50", "100", "250+"],
                        },
                        bar4: {
                            name: "Cookies n' Confection Gift Box w/ Confections",
                            options: ["25", "50", "100", "250+"],
                        },
                        bar5: {
                            name: "FB8 - Small Chocolate Confections Gift Box",
                            options: ["50", "100", "250", "500+"],
                            details: "fb8"
                        },
                        bar6: {
                            name: "FB16 - Medium Chocolate Confections Gift Box",
                            options: ["25", "50", "100", "250+"],
                            details: "fb16"
                        },
                        bar7: {
                            name: "FB36 - Large Chocolate Confections Gift Box",
                            options: ["25", "50", "100", "250+"],
                            details: "fb36"
                        },
                        bar8: {
                            name: "FBTR - Double Layer Chocolate Confections Gift Box",
                            options: ["12", "25", "50", "100+"],
                            details: "fbtr"
                        },
                        bar9: {
                            name: "FC2 - Small Custom 3D Chocolate Squares Gift Box",
                            options: ["100", "250", "500", "1,000","2,500+"],
                            details: "fc2"
                        },
                        bar10: {
                            name: "FC4 - Medium Custom 3D Chocolate Squares Gift Box",
                            options: ["100", "250", "500", "1,000","2,500+"],
                            details: "fc4"
                        },
                        bar11: {
                            name: "FC8 - Large Custom Chocolate Squares Gift Box",
                            options: ["100", "250", "500", "1,000","2,500+"],
                            details: "fc8"
                        },
                        bar12: {
                            name: "Heart Box with 3 Solid Heart Truffles",
                            options: ["50", "100", "250", "500+"],
                            details: "hb3"
                        },
                        bar13: {
                            name: "Chocolate Heart Box w/ Truffles",
                            options: ["50", "100", "250", "500+"],
                            details: "hbwt"
                        },
                        bar14: {
                            name: "Chocolate Heart Box w/ Confections",
                            options: ["50", "100", "250", "500+"],
                            details: "hbwc"
                        },
                        bar15: {
                            name: "Executive Wooden Chocolate Gift Box",
                            options: ["25", "50", "100", "250+"],
                            details: "ewcbg"
                        },
                        bar16: {
                            name: "Deluxe Wooden Chocolate Gift Boxes",
                            options: ["25", "50", "100", "250+"],
                            details: "dwcbg"
                        },
                        bar17: {
                            name: "SQ4 - Small Custom Chocolate Squares Gift Box",
                            options: ["50", "100", "250", "500+"],
                            details: "sq4"
                        },
                        bar18: {
                            name: "SQ8 - Medium Custom Chocolate Squares Gift Box",
                            options: ["50", "100", "250", "500+"],
                            details: "sq8"
                        },
                        bar19: {
                            name: "SQ16 - Large Custom Chocolate Squares Gift Box",
                            options: ["25", "50", "100", "250+"],
                            details: "sq16"
                        },
                        bar20: {
                            name: "SQ32 - Extra Large Custom Chocolate Squares Gift Box",
                            options: ["25", "50", "100", "250+"],
                            details: "sq32"
                        },
                        bar21: {
                            name: "SQ64 - Double Layer Custom Chocolate Squares Gift Box",
                            options: ["25", "50", "100", "250+"],
                            details: "sq64"
                        },
                        bar22: {
                            name: "TR8 - Small Chocolate Delights Gift Boxes",
                            options: ["50", "100", "250", "500+"],
                            details: "tr8"
                        },
                        bar23: {
                            name: "TR16 - Medium Chocolate Delights Gift Boxes",
                            options: ["25", "50", "100", "250+"],
                            details: "tr16"
                        },
                        bar24: {
                            name: "TR24 - Large Chocolate Delights Gift Boxes",
                            options: ["25", "50", "100", "250+"],
                            details: "tr24"
                        },
                        bar25: {
                            name: "TR48 - Extra Large Chocolate Delights Gift Boxes",
                            options: ["25", "50", "100", "250+"],
                            details: "tr48"
                        },
                        bar26: {
                            name: "BT2 - 2 Truffle Gift Box",
                            options: ["100", "250", "500", "1,000+"],
                            details: "bt2"
                        },
                        bar27: {
                            name: "BT4 - 4 Truffle Gift Box",
                            options: ["100", "250", "500", "1,000+"],
                            details: "bt4"
                        },
                        bar28: {
                            name: "BT8 - 8 Truffle Gift Box",
                            options: ["50", "100", "250", "500+"],
                            details: "bt8"
                        },
                        bar29: {
                            name: "BT9 - 9 Truffle Gift Box",
                            options: ["100", "250", "500", "1,000+"],
                            details: "bt9"
                        },
                        bar30: {
                            name: "BT12 - 12 Truffle Gift Box",
                            options: ["100", "250", "500", "1,000+"],
                            details: "bt12"
                        },
                        bar31: {
                            name: "BT20 - 20 Truffle Gift Box",
                            options: ["50", "100", "250", "500+"],
                            details: "bt20"
                        },

                    }

                },

                three_designs: {
                    name: "3D Designs",
                    options: {
                        bar1: {
                            name: "1lb Breakup Bar",
                            options: ["25", "50", "100", "250+"],
                        },
                        bar2: {
                            name: "2lb Breakup Bar",
                            options: ["25", "50", "100", "250+"],
                        },
                    }

                },

                custom_shapes: {
                    name: "Custom Shapes",
                    bar1: {
                        name: "Badge (2 oz.)",
                        options: ["100", "250", "500", "1,000+", "2,500+"],
                    },
                    bar2: {
                        name: "Globe 1 (5 oz.)",
                        options: ["100", "250", "500", "1,000+", "2,500+"],
                    },
                    bar3: {
                        name: "Globe 2 (1 1/2 oz.)",
                        options: ["100", "250", "500", "1,000+", "2,500+"],
                    },
                    bar4: {
                        name: "Cruise Ship (2 1/2 oz.)",
                        options: ["100", "250", "500", "1,000+", "2,500+"],
                    },
                    bar5: {
                        name: "Sneaker (1 oz.)",
                        options: ["100", "250", "500", "1,000+", "2,500+"],
                    },
                    bar6: {
                        name: "Boot (1 oz.)",
                        options: ["100", "250", "500", "1,000+", "2,500+"],
                    },
                    bar7: {
                        name: "Cowboy Hat (1 oz.)",
                        options: ["100", "250", "500", "1,000+", "2,500+"],
                    },
                    bar8: {
                        name: "Shovel (1 oz.)",
                        options: ["100", "250", "500", "1,000+", "2,500+"],
                    },
                    bar9: {
                        name: "Pencil (1 oz.)",
                        options: ["100", "250", "500", "1,000+", "2,500+"],
                    },
                    bar10: {
                        name: "Star (Gold or Silver Box)",
                        options: ["100", "250", "500", "1,000+", "2,500+"],
                    },
                    bar11: {
                        name: "Light Bulb (1 oz.)",
                        options: ["100", "250", "500", "1,000+", "2,500+"],
                    },
                    bar12: {
                        name: "USB Stick (1 oz.)",
                        options: ["100", "250", "500", "1,000+", "2,500+"],
                    },
                    bar13: {
                        name: "Mouse (1 oz.)",
                        options: ["100", "250", "500", "1,000+", "2,500+"],
                    },
                    bar14: {
                        name: "Cell Phone (4 oz.)",
                        options: ["100", "250", "500", "1,000+", "2,500+"],
                    },
                    bar15: {
                        name: "Computer (1 oz.)",
                        options: ["100", "250", "500", "1,000+", "2,500+"],
                    },

                },
                custom_cookies: {
                    name: "Custom Cookies",
                    bar1: {
                        name: "Round Chocolate Cookie",
                        options: ["100", "250", "500", "1,000+", "2,500+"],
                    },
                    bar2: {
                        name: "Rectangle Chocolate Cookie",
                        options: ["100", "250", "500", "1,000+", "2,500+"],
                    },
                    bar3: {
                        name: "Business Card Cookie Box",
                        options: ["100", "250", "500", "1,000+", "2,500+"],
                    },
                }

            }
        }
    },


    watch: {
        selectedProduct () {
            this.selectedBar = ''
        },

        selectedBar () {
            this.selectedQuantity = ''
        },

        productName () {
            this.form.productType = this.productName
        },

        barName () {
            this.form.productSubType = this.barName
        },

        quantityName () {
            this.form.quantity = this.quantityName
        }
    },


    methods: {
        submit () {

            this.isSubmitting = true

            let formData = new FormData()

            formData.append('name', this.form.name)
            formData.append('email', this.form.email)
            formData.append('telephone', this.form.telephone)
            formData.append('productType', this.form.productType)
            formData.append('productSubType', this.form.productSubType)
            formData.append('quantity', this.form.quantity)

            if (this.form.file) {
                formData.append('file', this.form.file)
            }

            formData.append('additional', this.form.additional)

            axios.post('/free-quote', formData ).then((response) => {
                this.isSubmitting = false
                window.location = response.data.redirect

            }).catch((e) => {
                this.isSubmitting = false
                alert('Something went wrong! try again')
            })
        },

        fileSelected (e) {
            this.form.file = e.target.files[0]
        }
    }
})
